__webpack_require__.p = "/bdnews24/assets/";